import { Component } from "@angular/core";
import { FloorplanDangerAreaMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/zone-menu/danger-area-menu/floorplan-danger-area-menu.component";
import { FloorplanDustExZoneMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/zone-menu/dust-ex-zone-menu/floorplan-dust-ex-zone-menu.component";
import { FloorplanExZoneMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/zone-menu/ex-zone-menu/floorplan-ex-zone-menu.component";
import { FloorplanWildcardZoneMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/zone-menu/wildcard-zone-menu/floorplan-wildcard-zone-menu.component";

@Component({
  selector: "app-floorplan-zone-menu",
  templateUrl: "./floorplan-zone-menu.component.html",
  imports: [
    FloorplanExZoneMenuComponent,
    FloorplanDangerAreaMenuComponent,
    FloorplanDustExZoneMenuComponent,
    FloorplanWildcardZoneMenuComponent,
  ],
})
export class FloorplanZoneMenuComponent {}
